export default {
  resource:{
    zh: {
      title:"用户",
      userNo: "用户编号",
      userName: "用户名",
      pwd:	"密码",
      roleNo:	"角色编号",
      roleName: "角色名",
      role:"角色",
      nullNo:"用户编号不能为空！",
      nullName:"用户名不能为空！",
      nullPwd:"密码不能为空！",
      companyName:"公司",
      status: "状态",
      status1: "正常",
      status0: "禁用",
      wechatId: "微信ID",
      alExists:"用户编号或用户名已经存在，请检查！"
    }

  },
  delConf:["userName"],
  delKeys:["autoid"],
  params: {
    userNo:{
      key: "userNo",
      data: null,
      method: "Equal",
      type: "text"
    },
    userName:{
      key: "userName",
      data: null,
      method: "Contains",
      type: "text"
    },
    roleName:{
      key: "roleName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "userNo","userName","roleName", {key:"status", formatter:"fstatus"}//, "wechatId"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "userNo",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "user/",
  formatter:{
    fstatus(v){
      return "status" + v
    }
  }
}
